module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/sparkles-bottom-shooting.89621d7f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/sparkles-bottom-shooting.png
// module id = 2846
// module chunks = 11